import { AgxBadgeType, NswContractStage, QldContractStage } from '@urbanx/agx-ui-components';

export const getContractStageBadgeType = (stage?: QldContractStage | NswContractStage) => {
  switch (stage) {
    case QldContractStage.Accepted:
    case NswContractStage.Accepted:
      return AgxBadgeType.Success;
    case QldContractStage.Unconditional:
    case NswContractStage.Unconditional:
      return AgxBadgeType.Waiting;
    case QldContractStage.Terminated:
    case NswContractStage.Terminated:
    case NswContractStage.Cancelled:
      return AgxBadgeType.Action;
    case QldContractStage.Settled:
    case NswContractStage.Settled:
      return AgxBadgeType.Needed;
    case NswContractStage.AwaitingExchange:
    case NswContractStage.Signing:
    case NswContractStage.BuyerSigning:
    case NswContractStage.VendorSigning:
      return AgxBadgeType.Action;
    case NswContractStage.ContractRequested:
      return AgxBadgeType.OnGoing;
    default:
      return AgxBadgeType.Primary;
  }
};
